import { ColumnKeys, InitAlertsResponse } from '@nirvana/shared/dtos/types/alerts/common';

export interface AlertsWebComponentSchema {
  // all the data needed for rendering
}

export const PREDEFINED_FILTERS_KEYS = [
  ColumnKeys.LAST_DETECTED,
  ColumnKeys.CATEGORY,
  ColumnKeys.ACTION_TAKEN,
  ColumnKeys.DEVICE_NAME,
  ColumnKeys.COMPANY,
];

export interface InitAlertsResponseFrontend extends InitAlertsResponse {
  isDrillDown: boolean;
  filterKeys: Array<ColumnKeys>;
  defaultSelectedTargetIds: Array<string>;
}

export enum RoutinesSeverity {
  LOW = 1,
  MEDIUM = 2,
  HIGH = 3,
}
